import { useController, useFormContext } from 'react-hook-form';
import InputComponent from './component';

const ColorPicker = ({
  name,
  required = false,
  label,
  defaultValue = [],
  images,
  defaultTab,
}) => {
  const { control } = useFormContext();

  const {
    field: { ref, value: inputValue, ...inputProps },
  } = useController({
    name,
    control,
    rules: { required },
    defaultValue,
    shouldUnregister: false,
  });

  return (
    <InputComponent
      name={name}
      label={label}
      inputRef={ref}
      value={inputValue}
      defaultTab={defaultTab}
      images={images}
      onChange={inputProps.onChange}
    />
  );
};

export default ColorPicker;
